import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { env } from '@constants';

const MERCHANT_LNG_RESOURCE = JSON.parse(window.sessionStorage.getItem('MERCHANT_LNG_RESOURCE')) || {};

const LANGUAGE_OPTION_BACK = [
  'en-US',
  'es-ES',
  'pl-PL',
  'pt-PT',
  'it-IT',
  'nl-NL',
  'de-DE',
  'cs-CZ',
  'fr-FR',
];

let LANGUAGE_RESOUCES_ENV;
if (env === 'local') {
  LANGUAGE_RESOUCES_ENV = 'dev';
} else if (env === 'dev' || env === 'test') {
  LANGUAGE_RESOUCES_ENV = 'test';
} else {
  LANGUAGE_RESOUCES_ENV = 'prod';
}

// 初始化 i18next
i18n.use(LanguageDetector).use(initReactI18next).init({
  // lng: "en", // 默认语言
  lng: localStorage.getItem('i18nextLng'), // 从 localStorage 恢复语言
  fallbackLng: 'en-US', // 找不到语言时回退到英文
  // 配置语言检测插件
  detection: {
    order: ['querystring', 'cookie', 'localStorage', 'navigator'], // 检测语言的优先级
    caches: ['localStorage', 'cookie'], // 缓存检测到的语言
  },
  // http-backend 配置项
  // backend: {
  //   loadPath: "https://saas-multilingual.s3.us-east-2.amazonaws.com/dev/RC/{{lng}}.json",
  //   crossDomain: true, // 如果需要跨域
  // },
  resources: {
    // en: {
    //   translation: {
    //     'Email Address / Phone Number': 'Email Address / Phone Number',
    //     'Invalid {{text}}': 'Invalid {{text}}',
    //     '{{text}} is required': '{{text}} is required',
    //     'Order Number / {{platform}}': 'Order Number / {{platform}}',
    //     'To begin, please provide us with your order details': 'To begin, please provide us with your order details',
    //     'Need help? Contact us at': 'Need help? Contact us at',
    //     'Invalid email address or order.': 'Invalid email address or order.',
    //     Next: 'Next',
    //     'Resolution Center': 'Resolution Center',
    //     Help: 'Help',
    //     'POWERED BY': 'POWERED BY',
    //     'Resolve issues': 'Resolve issues',
    //     with: 'with',
    //     'Order Number': 'Order Number',
    //     'Email address / Phone number': 'Email address / Phone number',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.',
    //   },
    // },
    // es: {
    //   translation: {
    //     'Email Address / Phone Number': 'Dirección de correo electrónico / Número de teléfono',
    //     'Invalid {{text}}': 'Inválido {{text}}',
    //     '{{text}} is required': '{{text}} es requerido',
    //     'Order Number / {{platform}}': 'Número de orden / {{platform}}',
    //     'To begin, please provide us with your order details': 'Para comenzar, proporciónenos los detalles de su pedido',
    //     'Need help? Contact us at': '¿Necesitas ayuda? Contáctenos en',
    //     'Invalid email address or order.': 'Dirección de correo electrónico o pedido inválido.',
    //     Next: 'Siguiente',
    //     'Resolution Center': 'Centro de resolución',
    //     Help: 'Ayuda',
    //     'POWERED BY': 'ALIMENTADO POR',
    //     'Resolve issues': 'Resolver problemas',
    //     with: 'con',
    //     'Order Number': 'Número de orden',
    //     'Email address / Phone number': 'Dirección de correo electrónico / Número de teléfono',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Lo siento, no se puede encontrar el pedido. Verifique si el número de pedido es correcto y si ha sido cancelado. Si tiene otros problemas, comuníquese con el comerciante.',
    //   },
    // },
    // pl: {
    //   translation: {
    //     'Email Address / Phone Number': 'Adres e-mail / Numer telefonu',
    //     'Invalid {{text}}': 'Nieprawidłowy {{text}}',
    //     '{{text}} is required': '{{text}} jest wymagany',
    //     'Order Number / {{platform}}': 'Numer zamówienia / {{platform}}',
    //     'To begin, please provide us with your order details': 'Aby rozpocząć, podaj nam szczegóły zamówienia',
    //     'Need help? Contact us at': 'Potrzebujesz pomocy? Skontaktuj się z nami pod adresem',
    //     'Invalid email address or order.': 'Nieprawidłowy adres e-mail lub zamówienie.',
    //     Next: 'Następny',
    //     'Resolution Center': 'Centrum rozwiązywania problemów',
    //     Help: 'Pomoc',
    //     'POWERED BY': 'NAPĘDZANY PR',
    //     'Resolve issues': 'Rozwiąż problemy',
    //     with: 'z',
    //     'Order Number': 'Numer zamówienia',
    //     'Email address / Phone number': 'Adres e-mail / Numer telefonu',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Przepraszamy, nie można znaleźć zamówienia. Sprawdź, czy numer zamówienia jest poprawny i czy został anulowany. Jeśli masz inne problemy, skontaktuj się z handlowcem.',
    //   },
    // },
    // pt: {
    //   translation: {
    //     'Email Address / Phone Number': 'Endereço de e-mail / Número de telefone',
    //     'Invalid {{text}}': 'Inválido {{text}}',
    //     '{{text}} is required': '{{text}} é obrigatório',
    //     'Order Number / {{platform}}': 'Número do pedido / {{platform}}',
    //     'To begin, please provide us with your order details': 'Para começar, forneça-nos os detalhes do seu pedido',
    //     'Need help? Contact us at': 'Precisa de ajuda? Entre em contato conosco em',
    //     'Invalid email address or order.': 'Endereço de e-mail ou pedido inválido.',
    //     Next: 'Próximo',
    //     'Resolution Center': 'Centro de resolução',
    //     Help: 'Ajuda',
    //     'POWERED BY': 'ALIMENTADO POR',
    //     'Resolve issues': 'Resolver problemas',
    //     with: 'com',
    //     'Order Number': 'Número do pedido',
    //     'Email address / Phone number': 'Endereço de e-mail / Número de telefone',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Desculpe, o pedido não pode ser encontrado. Verifique se o número do pedido está correto e se foi cancelado. Se tiver outros problemas, entre em contato com o comerciante.',
    //   },
    // },
    // it: {
    //   translation: {
    //     'Email Address / Phone Number': 'Indirizzo email / Numero di telefono',
    //     'Invalid {{text}}': 'Non valido {{text}}',
    //     '{{text}} is required': '{{text}} è richiesto',
    //     'Order Number / {{platform}}': 'Numero d\'ordine / {{platform}}',
    //     'To begin, please provide us with your order details': 'Per iniziare, fornisci i dettagli del tuo ordine',
    //     'Need help? Contact us at': 'Hai bisogno di aiuto? Contattaci a',
    //     'Invalid email address or order.': 'Indirizzo email o ordine non valido.',
    //     Next: 'Il prossimo',
    //     'Resolution Center': 'Centro risoluzioni',
    //     Help: 'Aiuto',
    //     'POWERED BY': 'ALIMENTATO DA',
    //     'Resolve issues': 'Risolvere i problemi',
    //     with: 'con',
    //     'Order Number': 'Numero d\'ordine',
    //     'Email address / Phone number': 'Indirizzo email / Numero di telefono',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Spiacente, l\'ordine non può essere trovato. Verifica se il numero d\'ordine è corretto e se è stato annullato. Se hai altri problemi, contatta il commerciante.',
    //   },
    // },
    // nl: {
    //   translation: {
    //     'Email Address / Phone Number': 'E-mailadres / Telefoonnummer',
    //     'Invalid {{text}}': 'Ongeldig {{text}}',
    //     '{{text}} is required': '{{text}} is verplicht',
    //     'Order Number / {{platform}}': 'Bestelnummer / {{platform}}',
    //     'To begin, please provide us with your order details': 'Om te beginnen, geef ons uw bestelgegevens',
    //     'Need help? Contact us at': 'Hulp nodig? Neem contact met ons op via',
    //     'Invalid email address or order.': 'Ongeldig e-mailadres of bestelling.',
    //     Next: 'Volgende',
    //     'Resolution Center': 'Oplossingscentrum',
    //     Help: 'Help',
    //     'POWERED BY': 'AANGEDREVEN DOOR',
    //     'Resolve issues': 'Problemen oplossen',
    //     with: 'met',
    //     'Order Number': 'Bestelnummer',
    //     'Email address / Phone number': 'E-mailadres / Telefoonnummer',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Sorry, de bestelling kan niet worden gevonden. Controleer of het bestelnummer correct is en of het is geannuleerd. Als u andere problemen heeft, neem dan contact op met de handelaar.',
    //   },
    // },
    // de: {
    //   translation: {
    //     'Email Address / Phone Number': 'E-Mail-Adresse / Telefonnummer',
    //     'Invalid {{text}}': 'Ungültig {{text}}',
    //     '{{text}} is required': '{{text}} ist erforderlich',
    //     'Order Number / {{platform}}': 'Bestellnummer / {{platform}}',
    //     'To begin, please provide us with your order details': 'Um zu beginnen, geben Sie uns bitte Ihre Bestelldetails',
    //     'Need help? Contact us at': 'Brauchen Sie Hilfe? Kontaktieren Sie uns unter',
    //     'Invalid email address or order.': 'Ungültige E-Mail-Adresse oder Bestellung.',
    //     Next: 'Nächster',
    //     'Resolution Center': 'Lösungszentrum',
    //     Help: 'Hilfe',
    //     'POWERED BY': 'ANGETRIEBEN VON',
    //     'Resolve issues': 'Probleme lösen',
    //     with: 'mit',
    //     'Order Number': 'Bestellnummer',
    //     'Email address / Phone number': 'E-Mail-Adresse / Telefonnummer',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Entschuldigung, die Bestellung kann nicht gefunden werden. Überprüfen Sie, ob die Bestellnummer korrekt ist und ob sie storniert wurde. Wenn Sie andere Probleme haben, wenden Sie sich bitte an den Händler.',
    //   },
    // },
    // cs: {
    //   translation: {
    //     'Email Address / Phone Number': 'E-mailová adresa / Telefonní číslo',
    //     'Invalid {{text}}': 'Neplatný {{text}}',
    //     '{{text}} is required': '{{text}} je povinný',
    //     'Order Number / {{platform}}': 'Číslo objednávky / {{platform}}',
    //     'To begin, please provide us with your order details': 'Pro začátek nám poskytněte podrobnosti o vaší objednávce',
    //     'Need help? Contact us at': 'Potřebujete pomoc? Kontaktujte nás na',
    //     'Invalid email address or order.': 'Neplatná e-mailová adresa nebo objednávka.',
    //     Next: 'Další',
    //     'Resolution Center': 'Centrum řešení',
    //     Help: 'Pomoc',
    //     'POWERED BY': 'POHÁNĚNO',
    //     'Resolve issues': 'Vyřešit problémy',
    //     with: 's',
    //     'Order Number': 'Číslo objednávky',
    //     'Email address / Phone number': 'E-mailová adresa / Telefonní číslo',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Omlouváme se, objednávka nebyla nalezena. Zkontrolujte, zda je číslo objednávky správné a zda bylo zrušeno. Pokud máte další problémy, kontaktujte obchodníka.',
    //   },
    // },
    // fr: {
    //   translation: {
    //     'Email Address / Phone Number': 'Adresse e-mail / Numéro de téléphone',
    //     'Invalid {{text}}': 'Invalide {{text}}',
    //     '{{text}} is required': '{{text}} est requis',
    //     'Order Number / {{platform}}': 'Numéro de commande / {{platform}}',
    //     'To begin, please provide us with your order details': 'Pour commencer, veuillez nous fournir les détails de votre commande',
    //     'Need help? Contact us at': 'Besoin d\'aide? Contactez-nous à',
    //     'Invalid email address or order.': 'Adresse e-mail ou commande invalide.',
    //     Next: 'Prochain',
    //     'Resolution Center': 'Centre de résolution',
    //     Help: 'Aide',
    //     'POWERED BY': 'ALIMENTÉ PAR',
    //     'Resolve issues': 'Résoudre les problèmes',
    //     with: 'avec',
    //     'Order Number': 'Numéro de commande',
    //     'Email address / Phone number': 'Adresse e-mail / Numéro de téléphone',
    //     'Sorry, the order cannot be found. Please check if the order number is correct and whether it has been canceled. If you have any other issues, please contact the merchant.': 'Désolé, la commande ne peut pas être trouvée. Veuillez vérifier si le numéro de commande est correct et s\'il a été annulé. Si vous avez d\'autres problèmes, veuillez contacter le commerçant.',
    //   },
    // },
  }, // 初始语言资源为空，动态加载
  interpolation: {
    escapeValue: false, // React 已经对 XSS 进行了处理
  },
  keyAsDefaultValue: true, // 启用 i18nKey 作为默认值
  // debug: true, // 开启调试模式
});

export const loadMerchantAResources = async (lng) => {
  try {
    // eslint-disable-next-line no-param-reassign
    if (!lng) lng = i18n.language || localStorage.getItem('i18nextLng') || navigator.language || 'en-US';
    const urls = [];
    if (!MERCHANT_LNG_RESOURCE[lng]) {
      urls.push(`https://saas-multilingual.s3.us-east-2.amazonaws.com/${LANGUAGE_RESOUCES_ENV}/RC/common/${lng}.json`);
      // urls.push(`/locales/${lng}.json`);
      MERCHANT_LNG_RESOURCE[lng] = true;
    }

    const responses = await Promise.all(urls.map((item) => fetch(item).then((res) => {
      if (!res.ok) {
        console.log(`Error fetching resource: ${res.status} ${res.statusText}`);
        return {}; // 返回空对象以便合并
      }
      return res.json();
    }).catch(() => {
      console.log('Error fetching:');
      return {}; // 返回空对象以便合并
    })));
    let resources = {};
    if (window.sessionStorage.getItem(`MERCHANT_LNG_RESOURCE_RESOURCE_${lng}`) && urls.length === 0) {
      resources = JSON.parse(window.sessionStorage.getItem(`MERCHANT_LNG_RESOURCE_RESOURCE_${lng}`));
    } else {
      const preResources = window.sessionStorage.getItem(`MERCHANT_LNG_RESOURCE_RESOURCE_${lng}`) ? JSON.parse(window.sessionStorage.getItem(`MERCHANT_LNG_RESOURCE_RESOURCE_${lng}`)) : {};
      resources = Object.assign({}, preResources, ...responses);
      window.sessionStorage.setItem(`MERCHANT_LNG_RESOURCE_RESOURCE_${lng}`, JSON.stringify(resources));
    }
    // 添加到 i18next
    i18n.addResourceBundle(lng, 'translation', resources, true, true);
    i18n.changeLanguage(lng); // 切换语言 触发重新渲染
    window.sessionStorage.setItem('MERCHANT_LNG_RESOURCE', JSON.stringify(MERCHANT_LNG_RESOURCE));
    console.log('Merged resources:', responses);
  } catch (error) {
    console.error('Error loading merchant resources:', error);
  }
};

loadMerchantAResources();

// 动态更新语言资源
export const updateTranslations = async (lang) => {
  // if (!MERCHANT_LNG_RESOURCE[lang]) await loadMerchantAResources(lang);
  await loadMerchantAResources(lang);
  i18n.changeLanguage(lang); // 切换语言
};

i18n.on('languageChanged', (lng) => {
  console.log('Language changed to:', lng);
  const isIniti18n = window.localStorage.getItem('isIniti18N');
  if (!isIniti18n) {
    window.localStorage.setItem('isIniti18N', 'true');
    if (LANGUAGE_OPTION_BACK.includes(lng)) {
      return;
    }
    // window.location.reload();
    // 2. 匹配前缀（如 en）
    const prefix = lng.split('-')[0];
    const matchedPrefix = LANGUAGE_OPTION_BACK.find((key) => key.startsWith(prefix));
    if (matchedPrefix) {
      i18n.changeLanguage(matchedPrefix);
      // loadMerchantAResources(matchedPrefix);
    } else {
      // 3. 使用兜底语言
      i18n.changeLanguage('en-US');
      // loadMerchantAResources('en-US');
    }
  }
  // 在这里执行你的逻辑，比如记录日志或加载特定资源
});

export default i18n;
